<template>
    <div>
        <el-form class="detail-form-content" ref="ruleForm" :model="ruleForm" :rules="rules" label-width="120px">
            <el-form-item label="头像" class="input" prop="headPicture">
                <el-upload
                        ref="upload"
                        :action="fileUploadUrl"
                        list-type="picture-card"
                        :multiple="multiple"
                        :limit="1"
                        :headers="myHeaders"
                        :file-list="fileList"
                        :on-exceed="handleExceed"
                        :on-success="handleUploadSuccess"
                        style="float:left;margin-left: 5%;"
                >
                    <i class="el-icon-plus"></i>
                </el-upload>
                <img v-if="ruleForm.headPicture" :src="url+'upload/'+ruleForm.headPicture" style="width:150px;height:150px"/>
            </el-form-item>
            <el-form-item label="姓名" class="input" prop="fullName">
                <el-input v-model="ruleForm.fullName" autocomplete="off" placeholder="请输入姓名" />
            </el-form-item>
            <el-form-item label="账号" class="input" prop="account">
                <el-input v-model="ruleForm.account" autocomplete="off" placeholder="请输入账号" />
            </el-form-item>
            <el-form-item label="性别" class="input" prop="sex" >
                <!--<el-select v-model="ruleForm.sex" style="width:85%">
                    <el-option :label="'男'" :value="'1'"></el-option>
                    <el-option :label="'女'" :value="'2'"></el-option>
                </el-select>-->
                <el-radio v-model="ruleForm.sex" label="1">男</el-radio>
                <el-radio v-model="ruleForm.sex" label="2">女</el-radio>
            </el-form-item>
            <!--<el-form-item label="是否锁定" class="input" prop="islock" >
                <el-select v-model="ruleForm.islock" style="width:85%;">
                    <el-option :label="'锁定'" :value="'0'"></el-option>
                    <el-option :label="'正常'" :value="'1'"></el-option>
                </el-select>
            </el-form-item>-->
            <el-form-item label="邮箱" class="input" prop="email">
                <el-input v-model="ruleForm.email" autocomplete="off" placeholder="请输入邮箱" />
            </el-form-item>
            <el-form-item label="电话" class="input" prop="phone">
                <el-input v-model="ruleForm.phone" autocomplete="off" placeholder="请输入电话" />
            </el-form-item>
            <el-form-item label="手机" class="input" prop="mobile">
                <el-input v-model="ruleForm.mobile" autocomplete="off" placeholder="请输入手机" />
            </el-form-item>
            <div style="display: flex;flex-wrap: wrap;width: 100%;justify-content: center;">
                <el-button class="btn" type="primary"  @click="commit()">保存</el-button>
            </div>
        </el-form>
    </div>
</template>
<script>
    // 数字，邮件，手机，url，身份证校验
    import { isNumber,isIntNumer,isEmail,isMobile,isPhone,isURL,checkIdCard } from "@/utils/validate";
    import base from '@/utils/base';
    export default {
        data() {
            return {
                url:base.get().url,
                fileUploadUrl:base.get().fileUploadUrl,
                ruleForm: {
                    fullName:'',
                    account:'',
                    password:'',
                    sex:'',
                    islock:'',
                    email:'',
                    phone:'',
                    mobile:'',
                    headPicture:'',
                },
                rules:{
                    fullName:[{ required: true, message: '请输入姓名', trigger: 'blur' }],
                    account:[{ required: true, message: '请输入账号', trigger: 'blur' }],
                    password:[{ required: true, message: '请输入密码', trigger: 'blur' }],
                    sex:[{ required: true, message: '请选择性别', trigger: 'blur' }],
                    /*email:[{ required: true, message: '请输入邮箱', trigger: 'blur' }],
                    phone:[{ required: true, message: '请输入电话', trigger: 'blur' }],*/
                    mobile:[
                        { required: true, message: '请输入手机号', trigger: 'blur' },
                        { pattern: /^1[3-9]\d{9}$/, message: '手机号格式不正确', trigger: 'blur' }
                    ],
                },
            };
        },
        mounted() {
            this.$http({
                url: "users/session",
                method: "get",
            }).then(({data}) => {
                if(data && data.code === 0){
                    this.ruleForm = data.data;
                }
            });
        },
        methods: {
            commit(){
                this.$refs['ruleForm'].validate((valid) => {
                    if (valid) {
                        this.$http({
                            url: '/users/update?selectRoleIds=',
                            method: "post",
                            data:this.ruleForm
                        }).then(({ data }) => {
                            if (data && data.code === 0) {
                                this.$message({
                                    message: "保存成功",
                                    type: "success",
                                    duration: 1500,
                                    onClose: () => {
                                        this.close();
                                    }
                                });
                            } else {
                                this.$message.error(data.msg);
                            }
                        });
                    }
                });
            }
        }
    };
</script>
<style lang="scss" scoped>
</style>
